import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CurrentUserBureauDto, UpdateCurrentUserBureauDto } from '../models/user-dto.model';
import { AppConfigService } from '../config/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class BureauService {
  private appConfig = inject(AppConfigService);

  private get bureauUrl(): string {
    return `${this.appConfig.backendUrl}/api/v1/bureau`;
  }

  constructor(private http: HttpClient) {}

  getCurrentBureau(): Observable<CurrentUserBureauDto> {
    return this.http.get<CurrentUserBureauDto>(this.bureauUrl);
  }

  updateCurrentBureau(body: UpdateCurrentUserBureauDto): Observable<unknown> {
    return this.http.put<unknown>(this.bureauUrl, body);
  }
}
